import Reveal from "@/components/Reveal";
import { Wind, Sun, Target, Baby, HandHeart, Moon, Brain, Leaf } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

const baseItems = [
  { icon: Wind, title: "Stress & anxiety", text: "Release tension and quiet a busy mind.", bg: "bg-sage" },
  { icon: Sun, title: "Self-confidence", text: "Reconnect with your inner resources.", bg: "bg-cream" },
  { icon: Target, title: "Focus & performance", text: "Sharpen mental clarity when it matters most.", bg: "bg-peach" },
  { icon: Baby, title: "Pre & post natal", text: "Gentle support through pregnancy and beyond.", bg: "bg-cream" },
  { icon: HandHeart, title: "Pain management", text: "Soften chronic pain through deep relaxation.", bg: "bg-peach" },
  { icon: Moon, title: "Sleep improvement", text: "Rebuild deep, restorative rest, night after night.", bg: "bg-sage" },
  { icon: Brain, title: "Concentration", text: "Train attention for study, work and sport.", bg: "bg-cream" },
];

export default function Specialties() {
  const { t } = useLang();
  const items = baseItems.map((it, i) => ({ ...it, ...t.specialties.items[i] }));
  return (
    <section id="specialties" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-36" data-testid="specialties-section">
      <Reveal>
        <p className="mb-6 text-xs font-semibold uppercase tracking-[0.3em] text-stone">{t.specialties.eyebrow}</p>
        <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl">
          {t.specialties.h2a}<em className="italic font-light text-moss">{t.specialties.h2b}</em>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item, i) => (
          <Reveal key={item.title} delay={(i % 4) * 0.08}>
            <div
              className={`group h-full rounded-[2rem] border border-forest/10 ${item.bg} p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_45px_-20px_rgba(44,53,40,0.2)]`}
              data-testid={`specialty-card-${i}`}
            >
              <item.icon size={30} weight="duotone" className="text-moss transition-transform duration-500 group-hover:scale-110" />
              <h3 className="mt-6 font-serif text-2xl tracking-tight">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-moss">{item.text}</p>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.1}>
          <div className="flex h-full flex-col justify-between rounded-[2rem] bg-forest p-8 text-cream" data-testid="audiences-card">
            <Leaf size={30} weight="duotone" className="text-sagedeep" />
            <div>
              <h3 className="mt-6 font-serif text-2xl italic tracking-tight">{t.specialties.audienceTitle}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/80">
                {t.specialties.audienceText}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
